import React from 'react';

import type { ReactNode } from 'react';

import useDeviceType from '@travel/traveler-core/hooks/useDeviceType';

import ContentsCarousel from 'components/ContentsCarousel';

import type { Items } from '../index';

import styles from './itemContainer.module.scss';

type ItemContainerProps = {
  title: ReactNode;
  children: ReactNode;
  items: Items;
  currentItems: string;
  isDirectContract?: boolean;
};

export default function ItemContainer({
  title,
  children,
  items,
  currentItems,
  isDirectContract = true,
}: ItemContainerProps) {
  const isPC = useDeviceType() === 'pc';
  const isSP = useDeviceType() === 'sp';

  // please update accordingly if there is any changes on scss
  const cardGap = 16; // 16px flex-gap
  const TL_IMAGE_WIDTH = isDirectContract ? 172 : 358;
  const PC_IMAGE_WIDTH = isDirectContract ? 278 : 358;

  const cardWidth = isPC ? PC_IMAGE_WIDTH : TL_IMAGE_WIDTH;

  return isSP ? (
    items === currentItems ? (
      <div className={styles.card}>
        <p className={styles.cardTitle}>{title}</p>
        {children}
      </div>
    ) : null
  ) : (
    <div className={styles.section}>
      <p className={styles.sectionTitle}>{title}</p>
      <ContentsCarousel
        fixedCardWidth={cardWidth + cardGap}
        className={styles.carousel}
        navButtonClassName={styles.carouselButton}
      >
        {children}
      </ContentsCarousel>
    </div>
  );
}
